import { useState } from 'react';
import PanelLayout from '../components/PanelLayout';

interface Note {
  id: number;
  title: string;
  content: string;
  createdAt: string;
  updatedAt: string;
}

const initialNotes: Note[] = [
  {
    id: 1,
    title: 'Antalya otel görüşmesi notları',
    content: 'Resort Spa ile yapılan görüşmede sezonluk çalışma teklifi alındı. Konaklama + yemek dahil. Maaş 90K-120K bandında. Hamam ve masaj uzmanlığı isteniyor. 15 Haziran başlangıç.',
    createdAt: '19 Mayıs 2026',
    updatedAt: '19 Mayıs 2026',
  },
  {
    id: 2,
    title: 'Kayseri termal merkezi - dikkat edilecekler',
    content: 'Part-time çalışma modeli uygun. SGK müzakeresi gerekiyor. Esnek saatler avantajlı. Sezon dışı yoğunluk düşük olabilir.',
    createdAt: '18 Mayıs 2026',
    updatedAt: '20 Mayıs 2026',
  },
  {
    id: 3,
    title: 'Profil güncelleme listesi',
    content: '1. Hamam sertifikası ekle\n2. Mini bio güncelle - aromaterapi deneyimini vurgula\n3. Yeni fotoğraf yükle\n4. Kayseri şehir tercihine ekle',
    createdAt: '15 Mayıs 2026',
    updatedAt: '15 Mayıs 2026',
  },
];

export default function NotlarimPage() {
  const [notes, setNotes] = useState<Note[]>(initialNotes);
  const [editingId, setEditingId] = useState<number | null>(null);
  const [newNoteOpen, setNewNoteOpen] = useState(false);
  const [form, setForm] = useState({ title: '', content: '' });

  const handleSave = () => {
    if (!form.title.trim() || !form.content.trim()) return;

    if (editingId !== null) {
      setNotes((prev) =>
        prev.map((n) =>
          n.id === editingId
            ? { ...n, title: form.title, content: form.content, updatedAt: '20 Mayıs 2026' }
            : n
        )
      );
      setEditingId(null);
    } else {
      const newNote: Note = {
        id: Date.now(),
        title: form.title,
        content: form.content,
        createdAt: '20 Mayıs 2026',
        updatedAt: '20 Mayıs 2026',
      };
      setNotes([newNote, ...notes]);
      setNewNoteOpen(false);
    }
    setForm({ title: '', content: '' });
  };

  const handleEdit = (note: Note) => {
    setForm({ title: note.title, content: note.content });
    setEditingId(note.id);
    setNewNoteOpen(false);
  };

  const handleDelete = (id: number) => {
    setNotes((prev) => prev.filter((n) => n.id !== id));
    if (editingId === id) {
      setEditingId(null);
      setForm({ title: '', content: '' });
    }
  };

  const cancelEdit = () => {
    setEditingId(null);
    setNewNoteOpen(false);
    setForm({ title: '', content: '' });
  };

  return (
    <PanelLayout>
      <div className="max-w-4xl mx-auto">
        <div className="flex items-center justify-between mb-6">
          <div>
            <h1 className="text-xl md:text-2xl font-bold text-deep-navy-500">Notlarım</h1>
            <p className="text-sm text-gray-500 mt-1">
              Sadece size özel notlar. Kimse göremez, düzenleyebilir ve silebilirsiniz.
            </p>
          </div>
          <button
            onClick={() => {
              setNewNoteOpen(true);
              setEditingId(null);
              setForm({ title: '', content: '' });
            }}
            className="px-4 py-2 rounded-lg bg-dark-teal-500 text-white text-sm font-semibold hover:bg-dark-teal-600 transition-colors cursor-pointer whitespace-nowrap"
          >
            <span className="flex items-center gap-1.5">
              <span className="w-4 h-4 flex items-center justify-center">
                <i className="ri-add-line text-sm" />
              </span>
              Yeni Not
            </span>
          </button>
        </div>

        {/* Privacy Notice */}
        <div className="bg-dark-teal-50 border border-dark-teal-100 rounded-xl p-4 mb-6 flex items-start gap-3">
          <span className="w-5 h-5 flex items-center justify-center text-dark-teal-500 shrink-0 mt-0.5">
            <i className="ri-lock-line text-base" />
          </span>
          <div>
            <p className="text-sm font-medium text-dark-teal-700">Tamamen gizli</p>
            <p className="text-xs text-dark-teal-600 mt-0.5">
              Bu notları sadece siz görebilirsiniz. Spa işletmeleri, admin veya başka hiçbir kullanıcı erişemez.
            </p>
          </div>
        </div>

        {/* New / Edit Form */}
        {(newNoteOpen || editingId !== null) && (
          <div className="bg-white rounded-xl border border-gray-100 p-5 mb-6">
            <h3 className="text-sm font-semibold text-deep-navy-500 mb-4">
              {editingId !== null ? 'Notu Düzenle' : 'Yeni Not'}
            </h3>
            <div className="space-y-4">
              <div>
                <label className="block text-sm font-medium text-deep-navy-500 mb-1.5">Başlık</label>
                <input
                  type="text"
                  value={form.title}
                  onChange={(e) => setForm({ ...form, title: e.target.value })}
                  className="w-full px-3 py-2.5 rounded-lg border border-gray-200 text-sm text-deep-navy-500 focus:outline-none focus:border-dark-teal-500"
                  placeholder="Not başlığı..."
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-deep-navy-500 mb-1.5">İçerik</label>
                <textarea
                  value={form.content}
                  onChange={(e) => setForm({ ...form, content: e.target.value })}
                  rows={5}
                  className="w-full px-3 py-2.5 rounded-lg border border-gray-200 text-sm text-deep-navy-500 focus:outline-none focus:border-dark-teal-500 resize-none"
                  placeholder="Notunuzu yazın..."
                />
              </div>
              <div className="flex gap-2">
                <button
                  onClick={handleSave}
                  className="px-5 py-2 rounded-lg bg-dark-teal-500 text-white text-sm font-semibold hover:bg-dark-teal-600 transition-colors cursor-pointer"
                >
                  {editingId !== null ? 'Güncelle' : 'Kaydet'}
                </button>
                <button
                  onClick={cancelEdit}
                  className="px-5 py-2 rounded-lg bg-gray-100 text-gray-600 text-sm font-medium hover:bg-gray-200 transition-colors cursor-pointer"
                >
                  İptal
                </button>
              </div>
            </div>
          </div>
        )}

        {/* Notes List */}
        <div className="space-y-4">
          {notes.map((note) => (
            <div
              key={note.id}
              className="bg-white rounded-xl border border-gray-100 p-5 hover:border-gray-200 transition-colors"
            >
              <div className="flex items-start justify-between gap-4 mb-2">
                <h3 className="text-sm font-semibold text-deep-navy-500">{note.title}</h3>
                <div className="flex items-center gap-1 shrink-0">
                  <button
                    onClick={() => handleEdit(note)}
                    className="w-8 h-8 flex items-center justify-center rounded-lg text-gray-400 hover:text-dark-teal-500 hover:bg-dark-teal-50 transition-colors cursor-pointer"
                    title="Düzenle"
                  >
                    <span className="w-4 h-4 flex items-center justify-center">
                      <i className="ri-edit-line text-sm" />
                    </span>
                  </button>
                  <button
                    onClick={() => handleDelete(note.id)}
                    className="w-8 h-8 flex items-center justify-center rounded-lg text-gray-400 hover:text-red-500 hover:bg-red-50 transition-colors cursor-pointer"
                    title="Sil"
                  >
                    <span className="w-4 h-4 flex items-center justify-center">
                      <i className="ri-delete-bin-line text-sm" />
                    </span>
                  </button>
                </div>
              </div>
              <p className="text-sm text-gray-600 whitespace-pre-line leading-relaxed">{note.content}</p>
              <div className="mt-3 flex items-center gap-3 text-[10px] text-gray-400">
                <span>Oluşturuldu: {note.createdAt}</span>
                {note.updatedAt !== note.createdAt && (
                  <span>Güncellendi: {note.updatedAt}</span>
                )}
              </div>
            </div>
          ))}
        </div>

        {notes.length === 0 && (
          <div className="text-center py-16">
            <span className="w-12 h-12 flex items-center justify-center mx-auto text-gray-300 mb-3">
              <i className="ri-sticky-note-line text-3xl" />
            </span>
            <p className="text-sm text-gray-500">Henüz not eklenmemiş.</p>
            <button
              onClick={() => {
                setNewNoteOpen(true);
                setEditingId(null);
                setForm({ title: '', content: '' });
              }}
              className="mt-2 text-xs text-dark-teal-500 font-medium hover:underline cursor-pointer"
            >
              İlk notunuzu ekleyin
            </button>
          </div>
        )}
      </div>
    </PanelLayout>
  );
}